import getCorePersonalStore from "../../../stores/core/core-personal-store";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import KhattabaMenu from "./KhattabaAdmin";
import NoneKhattabaMenu from "./NoneKhattabaAdmin";
import { HEADER_MENU_HEIGHT, HEADER_MENU_WIDTH } from "../header-constants";

const HeaderMenu = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={HEADER_MENU_WIDTH}
      height={HEADER_MENU_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        flexGrow: 1,
        flexShrink: 1,
        width: "auto",
        minWidth: 0,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      {isKhattabaAdmin ? <KhattabaMenu /> : <NoneKhattabaMenu />}
    </ET3Div>
  );
});

export default HeaderMenu;
